<template>
  <select :id="id" :class="pclass" v-if="isAjax == true&&list">
    <!-- <template v-for="(option, index) in copyList">
      <option :value="option.VAL" :key="index">{{ option.DISPLAY }}</option>
    </template>-->
  </select>
  <select :id="id" :class="pclass" v-else-if="list">
    <template v-for="(option, index) in copyList">
      <option :value="option.Value" :key="index" :title="option.title">
        {{
        option.Key
        }}
      </option>
    </template>
  </select>
</template>

<script>
import config from "@/config";
import { mapGetters } from "vuex";

export default {
  props: {
    id: String,
    list: Array,
    pclass: String,
    gridId: String,
    isAjax: Boolean,
    placeHolder: String,
    value: String,
    haveTitle: Boolean
  },
  data() {
    return {
      term: null,
      copyList: []
    };
  },
  watch: {
    value: function(val) {
      if (val == null || val == undefined) {
        this.clear();
      } else {
        $("#" + this.id)
          .val(val)
          .trigger("change");
      }
    },
    getIsFilterMode: function(val) {
      if (val) {
        if (this.isAjax) {
          this.select2Ajax();
        } else {
          this.select2();
        }
      }
    }
  },
  computed: {
    //for manual match only
    ...mapGetters("filters", ["getIsFilterMode"])
  },
  mounted() {
    if (this.isAjax) {
      //init only
      this.copyList = this.list.slice(0, 200);
      this.select2Ajax();
      this.$nextTick(() => {
        this.clear();
      });
      window.addEventListener("resize", this.select2Ajax);
      $("[data-toggle='sidebar']").click(() => {
        setTimeout(() => {
          this.select2Ajax();
        }, 500);
      });
    } else {
      //init only
      this.copyList = this.list.slice();
      this.select2();
      this.$nextTick(() => {
        this.clear();
      });
      window.addEventListener("resize", this.select2);
      $("[data-toggle='sidebar']").click(() => {
        setTimeout(() => {
          this.select2();
        }, 500);
      });
    }
  },
  methods: {
    clear() {
      $("#" + this.id)
        .val(null)
        .trigger("change");
    },
    select2Ajax() {
      let $vm = this;
      $("#" + this.id)
        .select2({
          placeholder: $vm.placeHolder,

          ajax: {
            // instead of writing the function to execute the request we use Select2's convenient helper
            type: "POST",
            crossDomain: true,
            url: config.serverURI + "/api/CCRS/select2_query",
            traditional: true,
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            data: function(term, page) {
              if (term.term) {
                $vm.copyList = $vm.list
                  .filter(item => item.VAL.includes(term.term))
                  .slice(0, 200);
              }
            },
            processResults: function(data, page) {
              // console.log(data);

              return {
                results: $.map($vm.copyList, function(item) {
                  return {
                    text: item.key,
                    id: item.value
                  };
                })
              };
            }
          }
        })
        .on("change", function() {
          $vm.$emit("input", this.value);
        });
    },

    select2() {
      let $vm = this;
      if (this.haveTitle) {
        $("#" + this.id)
          .select2({
            // allowClear: true,
            width: 'resolve',
            templateResult: $vm.formatOption,
            matcher: $vm.matchCustom
          })
          .on("change", function() {
            $vm.$emit("input", this.value);
          });
      } else {
        $("#" + this.id)
          .select2({})
          .on("change", function() {
            $vm.$emit("input", this.value);
          });
      }
      // $("#" + this.id).val(this.copyList);
    },
    matchCustom(params, data) {
      if ($.trim(params.term) === "") {
        return data;
      }
      let check = (v1, v2) => v1.toUpperCase().includes(v2.toUpperCase());
      if (check(data.text, params.term) || check(data.title, params.term)) {
        return data;
      }

      return null;
    },
    formatOption(option) {
      var $option = $(
        "<div><strong>" +
          option.text +
          "</strong></div>" +
          option.title +
          "</div>"
      );
      return $option;
    }
  }
};
</script>

<style></style>
